var map = {
	"./black_cured.png": 994,
	"./black_eradicated.png": 995,
	"./blue_cured.png": 996,
	"./blue_eradicated.png": 997,
	"./city-0.png": 998,
	"./city-1.png": 999,
	"./city-10.png": 1000,
	"./city-11.png": 1001,
	"./city-12.png": 1002,
	"./city-13.png": 1003,
	"./city-14.png": 1004,
	"./city-15.png": 1005,
	"./city-16.png": 1006,
	"./city-17.png": 1007,
	"./city-18.png": 1008,
	"./city-19.png": 1009,
	"./city-2.png": 1010,
	"./city-20.png": 1011,
	"./city-21.png": 1012,
	"./city-22.png": 1013,
	"./city-23.png": 1014,
	"./city-24.png": 1015,
	"./city-25.png": 1016,
	"./city-26.png": 1017,
	"./city-27.png": 1018,
	"./city-28.png": 1019,
	"./city-29.png": 1020,
	"./city-3.png": 1021,
	"./city-30.png": 1022,
	"./city-31.png": 1023,
	"./city-32.png": 1024,
	"./city-33.png": 1025,
	"./city-34.png": 1026,
	"./city-35.png": 1027,
	"./city-36.png": 1028,
	"./city-37.png": 1029,
	"./city-38.png": 1030,
	"./city-39.png": 1031,
	"./city-4.png": 1032,
	"./city-40.png": 1033,
	"./city-41.png": 1034,
	"./city-42.png": 1035,
	"./city-43.png": 1036,
	"./city-44.png": 1037,
	"./city-45.png": 1038,
	"./city-46.png": 1039,
	"./city-47.png": 1040,
	"./city-5.png": 1041,
	"./city-6.png": 1042,
	"./city-7.png": 1043,
	"./city-8.png": 1044,
	"./city-9.png": 1045,
	"./city_sel.png": 1046,
	"./cont_planner.png": 1047,
	"./crosshair.png": 1048,
	"./cube_black.png": 1049,
	"./cube_blue.png": 1050,
	"./cube_red.png": 1051,
	"./cube_yellow.png": 1052,
	"./disease_large_black.png": 1053,
	"./disease_large_blue.png": 1054,
	"./disease_large_red.png": 1055,
	"./disease_large_yellow.png": 1056,
	"./dispatcher.png": 1057,
	"./epidemic.png": 1058,
	"./event-airlift.png": 1059,
	"./event-forecast.png": 1060,
	"./event-gov_grant.png": 1061,
	"./event-one_quiet_night.png": 1062,
	"./event-res_pop.png": 1063,
	"./event.png": 1064,
	"./github.png": 426,
	"./infection_card.png": 1065,
	"./infection_rate.png": 286,
	"./linkedin.png": 427,
	"./map.png": 1066,
	"./map_epidemic.png": 1067,
	"./medic.png": 1068,
	"./ops_expert.png": 1069,
	"./outbreaks.png": 1070,
	"./outbreaks_filled.png": 1071,
	"./outbreaks_shape.png": 1072,
	"./player_card.png": 1073,
	"./quar_spec.png": 1074,
	"./red_cured.png": 1075,
	"./red_eradicated.png": 1076,
	"./researcher.png": 1077,
	"./scientist.png": 1078,
	"./station.png": 1079,
	"./twitter.png": 428,
	"./yellow_cured.png": 1080,
	"./yellow_eradicated.png": 1081
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1726;



/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images ^\.\/.*$
 ** module id = 1726
 ** module chunks = 0
 **/